export const initialState = {
    isDarkMode: false,
    mainLayout: 'app',
    theme: 'light',
    menu: 'vertical',
    layout: 'full',
    rtlClass: 'ltr',
    animation: '',
    navbar: 'navbar-sticky',
    locale: 'en',
    sidebar: false,
    languageList: [
        { code: 'zh', name: 'Chinese' },
        { code: 'da', name: 'Danish' },
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'French' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'hu', name: 'Hungarian' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'ru', name: 'Russian' },
        { code: 'es', name: 'Spanish' },
        { code: 'sv', name: 'Swedish' },
        { code: 'tr', name: 'Turkish' },
        { code: 'ae', name: 'Arabic' },
    ],
    isShowMainLoader: true,
    semidark: false,
};

function applyThemeToggle(state: typeof initialState, payload: string) {
    const theme = payload || state.theme;
    localStorage.setItem('theme', theme);
    let isDarkMode = state.isDarkMode || false;
    if (theme == 'light') {
        isDarkMode = false;
    } else if (theme == 'dark') {
        isDarkMode = true;
    } else if (theme == 'system') {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            isDarkMode = true;
        } else {
            isDarkMode = false;
        }
    }

    if (isDarkMode) {
        document.querySelector('body')?.classList.add('dark');
    } else {
        document.querySelector('body')?.classList.remove('dark');
    }
    return { ...state, theme, isDarkMode };
}

function applyAnimationToggle(state: typeof initialState, payload: string) {
    const animation = payload?.trim();
    localStorage.setItem('animation', animation);
    if (animation) {
        const eleanimation: any = document.querySelector('.animation');
        eleanimation?.classList.add('animate__animated');
        eleanimation?.classList.add(animation);
    }
    return { ...state, animation };
}

export function indexReducer(state = initialState, action: any) {
    const type = action.type;
    let payload = action.payload;
    if (type === 'toggleDirection') {
        localStorage.setItem('direction', payload);
        document.querySelector('html')?.setAttribute('dir', payload || 'ltr');
        return { ...state, ...{ direction: payload } };
    } else if (type === 'toggleMainLoader') {
        return { ...state, ...{ isShowMainLoader: payload } };
    }

    if (type === 'setMainLayout') {
        return { ...state, ...{ mainLayout: payload } };
    } else if (type === 'toggleTheme') {
        return applyThemeToggle(state, payload);
    } else if (type === 'toggleMenu') {
        payload = payload || state.menu;
        localStorage.setItem('menu', payload);
        return { ...state, ...{ sidebar: false, menu: payload } };
    } else if (type === 'toggleLayout') {
        payload = payload || state.layout;
        localStorage.setItem('layout', payload);
        return { ...state, ...{ layout: payload } };
    } else if (type === 'toggleRTL') {
        payload = payload || state.rtlClass;
        localStorage.setItem('rtlClass', payload);
        const rtlClass = payload;
        document.querySelector('html')?.setAttribute('dir', rtlClass || 'ltr');
        return { ...state, ...{ rtlClass: rtlClass } };
    } else if (type === 'toggleAnimation') {
        return applyAnimationToggle(state, payload);
    } else if (type === 'toggleNavbar') {
        payload = payload || state.navbar;
        localStorage.setItem('navbar', payload);
        return { ...state, ...{ navbar: payload } };
    } else if (type === 'toggleSemidark') {
        payload = payload || false;
        localStorage.setItem('semidark', payload);
        return { ...state, ...{ semidark: payload } };
    } else if (type === 'toggleLocale') {
        payload = payload || state.locale;
        localStorage.setItem('i18n_locale', payload);
        return { ...state, ...{ locale: payload } };
    } else if (type === 'toggleSidebar') {
        return { ...state, ...{ sidebar: !state.sidebar } };
    }

    return state;
}
